import API_URLS from '@Constants/apiUrls.constants';
import CommonConstants from '@Constants/common.constants';
import {
  ActiveSessionsResponse,
  CallLogReportQuery,
  CallLogReportResponse,
  EndActiveSessions,
  SessionsResponse,
  SessionsSummaryQuery,
  SessionsSummaryResponse,
  ActiveSessionsQuery,
  EmailLogReportResponse,
  EmailLogReportQuery,
} from '@Models/report.model';
import query from '@Utils/common/query.utils';

import { baseApi } from './baseApi.service';

export const reportApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [
      'Sessions',
      'CallLog',
      'SessionSummary',
      'ActiveSessions',
      'BleedOut',
      'EmailLog',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      /** GETS THE SESSIONS */
      getSessions: builder.query<SessionsResponse[], string[]>({
        query: (id) =>
          `${API_URLS.REPORT.SESSIONS}?${query.stringify({
            id,
          })}`,
        providesTags: ['Sessions'],
      }),

      /** GETS THE CALL-LOG REPORTS */
      getCallLogs: builder.query<CallLogReportResponse, CallLogReportQuery>({
        query: (callLogQuery) =>
          `${API_URLS.REPORT.CALL_LOG}?${query.stringify({ ...callLogQuery })}`,
        providesTags: ['CallLog'],
      }),

      /** GETS THE DIAL SESSIONS REPORTS */
      getSessionSummary: builder.query<
        SessionsSummaryResponse,
        SessionsSummaryQuery
      >({
        query: ({ direction, ...resSessionSummaryQuery }) =>
          `${API_URLS.REPORT.SESSIONS_SUMMARY}?${query.stringify({
            ...resSessionSummaryQuery,
          })}&${direction || CommonConstants.INITIAL_SORT_DIRECTION}`,
        providesTags: ['SessionSummary'],
      }),

      /** GETS THE ACTIVE SESSIONS */
      getActiveSessions: builder.query<
        ActiveSessionsResponse,
        ActiveSessionsQuery
      >({
        query: ({ direction, ...resActiveSessionsQuery }) =>
          `${API_URLS.REPORT.ACTIVE_SESSIONS}?${query.stringify({
            ...resActiveSessionsQuery,
          })}&${direction || CommonConstants.INITIAL_SORT_DIRECTION}`,
        providesTags: ['ActiveSessions'],
      }),

      /** STOPS THE ACTIVE SESSIONS */
      endSession: builder.mutation<EndActiveSessions, EndActiveSessions>({
        query: ({ ids }) => ({
          url: `/bulk-end-session`,
          method: 'POST',
          body: { sessionIds: ids },
        }),
        invalidatesTags: ['ActiveSessions', 'BleedOut'],
      }),

      /** GETS THE EMAIL-LOG REPORTS */
      getEmailLogs: builder.query<EmailLogReportResponse, EmailLogReportQuery>({
        query: (emailLogQuery) =>
          `${API_URLS.REPORT.EMAIL_LOG}?${query.stringify({
            ...emailLogQuery,
          })}`,
        providesTags: ['EmailLog'],
      }),
    }),

    overrideExisting: false,
  });

export const {
  useGetSessionsQuery,
  useGetActiveSessionsQuery,
  useEndSessionMutation,
  useGetCallLogsQuery,
  useGetSessionSummaryQuery,
  useGetEmailLogsQuery,
} = reportApi;
